import React from 'react';
import logo from '../assets/zarviya_symbol.png'; // Adjust the path to your logo image

const Spinner = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center">
      {/* Main spinner container */}
      <div className="relative z-10 flex items-center justify-center">
        {/* Spinning border - using conic-gradient with darker colors */}
        <div
          className="w-20 h-20 rounded-full animate-spin"
          style={{
            animationDuration: '2s',
            background: `conic-gradient(
              #2a081a,
              #6b5c54,
              #1a0d12,
              #8b7d75,
              #9c7d6f,
              #2a081a
            )`,
            padding: '2px',
          }}
        >
          {/* Inner circle to create the border effect */}
          <div
            className="w-full h-full rounded-full flex items-center justify-center"
            style={{
              background: `radial-gradient(circle at 30% 30%, #4c0f2e, #2a081a, #4c0f2e)`,
              backdropFilter: 'blur(10px)',
              boxShadow: 'inset 0 2px 8px rgba(255,255,255,0.1), inset 0 -2px 8px rgba(0,0,0,0.3)',
            }}
          >
            {/* Logo container - moved up slightly */}
            <div className="flex items-center justify-center -mt-6">
              <img
                src="https://res.cloudinary.com/dzzhbgbnp/image/upload/v1751134480/zarviya_symbol_v5wbc1.png"
                alt="Logo"
                className="w-16 h-16 object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }
      `}</style>
    </div>
  );
};

export default Spinner;
